import React, { useEffect, useState } from 'react';

const whiteLogo = '/assets/abyss_fabric_mini_logo_white.svg';
const blackLogo = '/assets/abyss_fabric_mini_logo_black.svg';

type Props = {
  height?: number;
  width?: number;
};

export const BlinkingAbyssLoader = ({ height = 80, width = 80 }: Props) => {
  const [loaderLogo, setLoaderLogo] = useState<string>(whiteLogo);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoaderLogo((previous) => (previous === whiteLogo ? blackLogo : whiteLogo));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <img
      src={loaderLogo}
      alt="loader"
      width={height}
      height={width}
      style={loaderLogo === blackLogo ? { filter: 'none' } : { filter: 'invert(60%)' }}
      data-testid="blinking-abyss-loader"
    />
  );
};
